import { daysSince } from "@/lib/skills/catalog";
import { reasonFor, SCENARIOS } from "@/lib/skills/constants";
import type { SkillListItem } from "@/lib/skills/types";

interface Recommendation {
  skill: SkillListItem;
  reason: string;
}

/** Rule-based, transparent recs: the scenario's skill slugs, published only, max 3. */
export function recommendationsFor(
  scenarioId: string,
  skills: SkillListItem[],
  now: Date = new Date(),
): Recommendation[] {
  const scenario = SCENARIOS.find((s) => s.id === scenarioId);
  if (!scenario) return [];
  const bySlug = new Map(skills.map((s) => [s.slug, s]));
  const picks: Recommendation[] = [];
  for (const slug of scenario.skills) {
    const skill = bySlug.get(slug);
    if (!skill?.published) continue;
    picks.push({
      skill,
      reason: reasonFor({
        rating: skill.rating,
        risk: skill.risk,
        downloads: skill.downloads,
        updatedDaysAgo: daysSince(skill.updatedAt, now),
      }),
    });
    if (picks.length === 3) break;
  }
  return picks;
}
